"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var client_1 = require("@apollo/client");
var graphql_tag_1 = __importDefault(require("graphql-tag"));
var ui_1 = require("@aperza/ui");
var AcToast_1 = require("../../notification/AcToast");
var AcButton_1 = require("../../button/AcButton");
var AcPdfSetPhraseEditor_1 = require("../phraseMenu/AcPdfSetPhraseEditor");
var AcSetPhraseStampButton_1 = require("../stamps/AcSetPhraseStampButton");
var AcPdfEditorSideMenu_1 = require("../AcPdfEditorSideMenu");
var AcStampButtonWrapper_1 = require("../stamps/AcStampButtonWrapper");
var AcPageTitle_1 = require("../../layout/AcPageTitle");
exports.faxSetPhraseFragment = graphql_tag_1.default(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment FaxSetPhrase on FaxSetPhrase {\n    id\n    faxSetPhraseId\n    companyContractFaxId\n    setPhrase\n  }\n"], ["\n  fragment FaxSetPhrase on FaxSetPhrase {\n    id\n    faxSetPhraseId\n    companyContractFaxId\n    setPhrase\n  }\n"])));
exports.queryAll = graphql_tag_1.default(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  query AcFaxSetPhraseQuery {\n    viewer {\n      id\n      faxSetPhrases {\n        ...FaxSetPhrase\n      }\n    }\n  }\n  ", "\n"], ["\n  query AcFaxSetPhraseQuery {\n    viewer {\n      id\n      faxSetPhrases {\n        ...FaxSetPhrase\n      }\n    }\n  }\n  ", "\n"])), exports.faxSetPhraseFragment);
exports.deleteFaxSetPhraseMutation = graphql_tag_1.default(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  mutation DeleteFaxContactMutation($input: DeleteFaxSetPhraseInput!) {\n    deleteFaxSetPhrase(input: $input) {\n      faxSetPhrase {\n        id\n      }\n    }\n  }\n"], ["\n  mutation DeleteFaxContactMutation($input: DeleteFaxSetPhraseInput!) {\n    deleteFaxSetPhrase(input: $input) {\n      faxSetPhrase {\n        id\n      }\n    }\n  }\n"])));
exports.AcPdfSetPhraseMenu = function (_a) {
    var _b = _a.width, width = _b === void 0 ? '100%' : _b, height = _a.height;
    var setActiveMenu = react_1.useContext(AcPdfEditorSideMenu_1.AcPdfEditorSideMenuContext).setActiveMenu;
    var _c = react_1.useState(false), showEditor = _c[0], setShowEditor = _c[1];
    var _d = client_1.useQuery(exports.queryAll), setPhrases = _d.data, refetchSetPhrases = _d.refetch, error = _d.error;
    var _e = react_1.useState(), selectedFaxSetPhrase = _e[0], setSelectedFaxSetPhrase = _e[1];
    var _f = client_1.useMutation(exports.deleteFaxSetPhraseMutation), deleteFaxSetPhrase = _f[0], loading = _f[1].loading;
    var windowHeight = ui_1.useWindowResize().windowHeight;
    var onBackwards = function () {
        if (setActiveMenu) {
            setActiveMenu('stampMenu');
        }
    };
    var createSetPhrase = function () {
        setSelectedFaxSetPhrase(undefined);
        setShowEditor(true);
    };
    var editSetPhrase = function (faxSetPhrase) {
        setSelectedFaxSetPhrase(faxSetPhrase);
        setShowEditor(true);
    };
    var deleteSetPhrase = function (faxSetPhrase) { return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (loading) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, deleteFaxSetPhrase({
                            variables: { input: { id: faxSetPhrase.faxSetPhraseId } },
                            refetchQueries: ['AcFaxSetPhraseQuery'],
                        })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    AcToast_1.notifyMessage('定型文の削除に失敗しました。', 'ERROR');
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var dropdownProps = {
        id: 'faxSetPhraseDropdown',
        title: react_1.default.createElement("i", { className: "fal fa-ellipsis-v-alt fa-fw text-secondary" }),
        alignRight: true,
        align: 'alignRight',
        disableDropdownIcon: true,
        size: 'sm',
        actions: [
            {
                name: '編集する',
                path: '#',
                icon: 'far fa-pencil',
                onClick: function (faxSetPhrase) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        editSetPhrase(faxSetPhrase);
                        return [2 /*return*/];
                    });
                }); },
            },
            {
                name: '削除する',
                path: '#',
                icon: 'far fa-trash-alt',
                onClick: function (faxSetPhrase) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        deleteSetPhrase(faxSetPhrase);
                        return [2 /*return*/];
                    });
                }); },
            },
        ],
    };
    react_1.useEffect(function () {
        refetchSetPhrases();
    }, [showEditor]);
    var header = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("span", { onClick: onBackwards, className: "p-0 btn text-apzlinkblue fs-18" },
            react_1.default.createElement("i", { className: "far fa-chevron-left fs-18 fa-fw" }),
            "\u623B\u308B")));
    var renderSetPhrases = function () {
        if (setPhrases && !error) {
            var faxSetPhrases = setPhrases.viewer.faxSetPhrases;
            if (faxSetPhrases.length > 0) {
                var faxSetPhraseButtons = faxSetPhrases.map(function (faxSetPhrase) {
                    return (react_1.default.createElement(AcSetPhraseStampButton_1.AcSetPhraseStampButton, { key: faxSetPhrase.faxSetPhraseId, text: faxSetPhrase.setPhrase, dropdownProps: dropdownProps, dropdownData: faxSetPhrase }));
                });
                var divMinHeightMin = 400;
                var divWindowHeight = windowHeight - 255;
                var divHeight = divMinHeightMin < divWindowHeight ? divWindowHeight : divMinHeightMin;
                return react_1.default.createElement(react_1.default.Fragment, null, faxSetPhraseButtons);
            }
        }
        return react_1.default.createElement(react_1.default.Fragment, null);
    };
    var createSetPhraseButton = (react_1.default.createElement("div", { className: "d-flex justify-content-center" },
        react_1.default.createElement(AcButton_1.AcButton, { variant: "outline-apzlinkblue", className: "px-6 py-3 rounded", size: "sm", disabled: loading, onClick: function () { return createSetPhrase(); } }, "\u5B9A\u578B\u6587\u306E\u65B0\u898F\u767B\u9332")));
    var notEditing = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(AcPageTitle_1.AcPageTitle, null, header),
        react_1.default.createElement(AcStampButtonWrapper_1.AcStampButtonWrapper, null, renderSetPhrases()),
        react_1.default.createElement("div", { className: "row justify-content-center" }, createSetPhraseButton)));
    return (react_1.default.createElement("div", { style: { width: width, height: height } }, showEditor ? (react_1.default.createElement(AcPdfSetPhraseEditor_1.AcPdfSetPhraseEditor, { faxSetPhrase: selectedFaxSetPhrase, backwards: function () { return setShowEditor(false); } })) : (notEditing)));
};
exports.AcPdfSetPhraseMenu.displayName = 'AcPdfSetPhraseMenu';
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=AcPdfSetPhraseMenu.js.map